import React from "react";
import Logo from "../logo/Logo";
import "./TitleAndLogo.scss";
import { withDefaults } from "../../utils/withDefaults";

export interface TitleAndLogoProps {
  shouldShowLogo?: boolean;
  title?: string;
}

export default function TitleAndLogo(incomingProps: TitleAndLogoProps) {
  const props = withDefaults(incomingProps, titleAndLogoDefaultProps);

  return (
    <div className="title-and-logo" data-testid="title-and-logo">
      {props.shouldShowLogo ? <Logo /> : null}
      <h1 className="modal-title">{props.title}</h1>
    </div>
  );
}

const titleAndLogoDefaultProps = {
  shouldShowLogo: true,
  title: ""
};
